import { render, staticRenderFns } from "./AddDocumentDialog.vue?vue&type=template&id=62376ee0&scoped=true"
import script from "./AddDocumentDialog.vue?vue&type=script&lang=js"
export * from "./AddDocumentDialog.vue?vue&type=script&lang=js"
import style0 from "./AddDocumentDialog.vue?vue&type=style&index=0&id=62376ee0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62376ee0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VSelect,VTextarea})
